import { Instance, SnapshotOut } from 'mobx-state-tree';
import CollectionMapProcessor from '~/mst/models/abstract/collection_map_processor';
import model from './model';
import actions from './actions';
import views from './views';

const DevicePofilesStore = model.views(views).actions(actions);

export interface IDevicePofilesStore extends Instance<typeof DevicePofilesStore> {}
export interface IDevicePofilesStoreSnapshot extends SnapshotOut<typeof DevicePofilesStore> {}

export default CollectionMapProcessor(DevicePofilesStore);
